import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Typography, Box } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import { resetSearch } from '../../../redux/actions/TableData';
import localization from '../../../localization';
import { copyText } from '../../../services/helpers/utils';

import Icons from '../../Icons';

import './сustomBreadcrumbs.scss';

const CustomBreadcrumbs = ({ sections, url, id = null }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const tableSearchKeys = useSelector(({ tableData: { search } }) => Object.keys(search));

  const filteredSections = [...sections].filter((item) => (id ? item !== id && item !== 'add' : item !== id));
  const isNoEmptySection = filteredSections.length && filteredSections[0] !== '';

  const handleCopyLink = (e) => {
    e.stopPropagation();
    copyText(window.location.href);
  };

  const handleCopyId = (value) => {
    copyText(value);
  };

  if (tableSearchKeys.length && !sections.includes(tableSearchKeys[0])) {
    dispatch(resetSearch());
  }

  return (
    <Box display="flex" flexDirection="row">
        {sections.length && (
          <Box mr="5px" className="iconButton">
            <Icons.CopyUrlIcon
              onClick={handleCopyLink}
              color="secondary"
            />
          </Box>
        )}
      {isNoEmptySection && filteredSections.map((section, index) => {
        const slash = index !== (filteredSections.length - 1) ? '/' : id ? '/' : '';
        const sectionName = localization.t(`sections.${section}`);

        return (
          <Typography
            key={`${section}_${index}`}
            variant="h5"
            color="primary"
            component="div"
            onClick={() => url && index === (filteredSections.length - 1) && history.push(url)}
          >
            <Box display="flex">
              <Box
                style={url && index === (filteredSections.length - 1) ? { cursor: 'pointer', textDecorationLine: 'underline', width: 'max-content' } : {}}
              >
                {`${sectionName}`}
              </Box>
              <Box px={0.5}>{`${slash}`}</Box>
            </Box>
          </Typography>
        );
      })}
      {id && sections.length >= 3 && (
        <FileCopyIcon
          color="secondary"
          onClick={() => handleCopyId(id)}
          className="iconButton"
       />
      )}
      <Typography component="div" color="secondary">
        <Box fontWeight={500}>
          <>&nbsp;</>
          {id}
        </Box>
      </Typography>
    </Box>
  );
};

CustomBreadcrumbs.propTypes = {
  sections: PropTypes.array,
  url: PropTypes.string,
  id: PropTypes.string,
};

export default CustomBreadcrumbs;
